import { FAILED, LOADING, SUCCESS } from './apiStatusTypes';
import { StatusTypes } from './loadingStatusTypes';

type State = {
  status: string;
  data?: any;
  error?: any;
};

type Action = {
  type: string;
  payload?: any;
};

export const reducer = (state: State, action: Action) => {
  switch (action.type) {
    case LOADING:
      return { ...state, status: StatusTypes.LOADING };
    case SUCCESS:
      return { ...state, status: StatusTypes.SUCCESS, data: action.payload };
    case FAILED:
      return { ...state, status: StatusTypes.FAILED, error: action.payload };

    default:
      return state;
  }
};

type StateWithType<D> = {
  status: StatusTypes;
  data: D;
  error?: Error;
};

type SuccessAction<D> = {
  type: StatusTypes.SUCCESS;
  payload: D;
};

type LoadingAction = {
  type: StatusTypes.LOADING;
};

type FailedAction = {
  type: StatusTypes.FAILED;
  payload: Error;
};

export const createTypedReducer =
  <D>() =>
  (
    state: StateWithType<D>,
    action: SuccessAction<D> | LoadingAction | FailedAction,
  ): StateWithType<D> => {
    switch (action.type) {
      case StatusTypes.LOADING:
        return { ...state, status: StatusTypes.LOADING };
      case StatusTypes.SUCCESS:
        return { ...state, status: StatusTypes.SUCCESS, data: action.payload };
      case StatusTypes.FAILED:
        return { ...state, status: StatusTypes.FAILED, error: action.payload };

      default:
        return state;
    }
  };
